module.exports = __webpack_public_path__ + "img/sort-up.66ad650b.svg";